// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailMatch_style_wrapper__t3S6r","error":"DetailMatch_style_error__leiUo","rotate":"DetailMatch_style_rotate__bxK9I"};